// Build-time feature visibility flags.
//
// VITE_HIDDEN_FEATURES is a comma-separated list of feature keys to hide
// from the customer-facing UI (nav, routes, command palette). Semantics:
//   - unset            → default hidden set (ads, attribution)
//   - explicit ""      → nothing hidden (show everything)
//   - "ads"            → only ads hidden
//
// The backend mirrors this declaration (same env var, same semantics) in
// app/services/help/feature_visibility.py so chat/help answers track the
// shipped UI; tests/unit/test_feature_visibility_sync.py fails on drift.
const DEFAULT_HIDDEN_FEATURES = ['ads', 'attribution']

function parseHiddenFeatures(): Set<string> {
  const raw = import.meta.env.VITE_HIDDEN_FEATURES
  if (raw === undefined) return new Set(DEFAULT_HIDDEN_FEATURES)
  const trimmed = raw.trim()
  if (trimmed === '') return new Set()
  return new Set(
    trimmed
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  )
}

export const HIDDEN_FEATURES = parseHiddenFeatures()

export function isFeatureHidden(key: string): boolean {
  return HIDDEN_FEATURES.has(key)
}
